import { render, staticRenderFns } from "./TheGenericReport.vue?vue&type=template&id=00965242&scoped=true&"
import script from "./TheGenericReport.vue?vue&type=script&lang=js&"
export * from "./TheGenericReport.vue?vue&type=script&lang=js&"
import style0 from "./TheGenericReport.vue?vue&type=style&index=0&id=00965242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00965242",
  null
  
)

export default component.exports